import React from 'react'
import styles from './styles.module.css'
import ZoomableImage from './ZoomableImage'

function ProductImages({ images }) {
  if (!images) {
    return null
  }

  if (images.length === 1) {
    return (
      <div className={styles.carouselWrapper}>
        <div className={styles.row}>
          <div className={styles.images}>
            <div className={styles.imageWrapper} key={images[0].src}>
              <ZoomableImage
                image={images[0]}
                alt={images[0].alt || ''}
                sizes="(max-width: 991px) 100vw, 70vw"
              />
            </div>
          </div>
        </div>
      </div>
    )
  }

  const firstRow = images.slice(0, 2)
  const secondRow = images.slice(2, 5)
  const thirdRow = images.slice(5, 8)

  return (
    <div className={styles.carouselWrapper}>
      <div className={styles.row}>
        <div className={styles.images}>
          { firstRow.map((image) => (
            <div className={styles.imageWrapper} key={image.src}>
              <ZoomableImage
                image={image}
                alt={image.alt || ''}
                sizes="(max-width: 991px) 50vw, 35vw"
              />
            </div>
          )) }
        </div>
      </div>
      {
        secondRow && secondRow.length > 0 && <div className={styles.row}>
          {/* A leftover row holding ONE tile would stretch it to the full gallery
              width (flex: 1 0 0) at aspect-ratio 4/3, i.e. double the height of
              the paired tiles above it, shoving everything below far down the
              page. Cap it to a normal tile width instead. */}
          <div className={secondRow.length === 1 ? `${styles.images} ${styles.imagesLeftover}` : styles.images}>
            { secondRow.map((image) => (
              <div className={styles.imageWrapper} key={image.src}>
                <ZoomableImage
                  image={image}
                  alt={image.alt || ''}
                  sizes={secondRow.length < 3 ? '(max-width: 991px) 50vw, 35vw' : '(max-width: 991px) 33vw, 25vw'}
                />
              </div>
            )) }
          </div>
        </div>
      }
      {
        thirdRow && thirdRow.length > 0 && <div className={styles.row}>
          <div className={thirdRow.length === 1 ? `${styles.images} ${styles.imagesLeftover}` : styles.images}>
            { thirdRow.map((image) => (
              <div className={styles.imageWrapper} key={image.src}>
                <ZoomableImage
                  image={image}
                  alt={image.alt || ''}
                  sizes="(max-width: 991px) 33vw, 25vw"
                />
              </div>
            )) }
          </div>
        </div>
      }
    </div>
  )
}

export default ProductImages
